export function checkWebpImgSupport(){
    var img = new Image();
    img.onload = function () {
        if (img.width > 0 && img.height > 0) {
        document.documentElement.classList.add('webp');
        } else {
        document.documentElement.classList.add('no-webp');
        }
    };
    img.onerror = function () {
        document.documentElement.classList.add('no-webp');
    };
    img.src = "data:image/webp;base64,UklGRhYAAABXRUJQVlA4TA0AAAAvAAAAHAAAQUxQSAIAAAAAQU5JTQAAAD0AAAAvAAAACZkY5gAA";
}